import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  maxWidth?: string;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'max-w-2xl'
}: ModalProps) {
  // Lock body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-275">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-276" />

      {/* Panel */}
      <div className={`relative w-full ${maxWidth} bg-white rounded-xl shadow-2xl border border-slate-200 flex flex-col max-h-[90vh]`} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-277">
        {/* Header */}
        {title && <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 shrink-0" data-id="element-278">
            <h2 id="modal-title" className="text-base font-semibold text-slate-900" data-id="element-279">
              {title}
            </h2>
            <button onClick={onClose} className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-md transition-colors" aria-label="Close" data-id="element-280">
              <X className="h-4 w-4" data-id="element-281" />
            </button>
          </div>}

        {/* Body */}
        <div className="overflow-y-auto flex-1 px-6 py-5" data-id="element-282">{children}</div>
      </div>
    </div>;
}